import { useAppSelector } from "../redux/app/hooks";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";

type Props = {};

const CartButton = (props: Props) => {
  const cart = useAppSelector((state) => state.leadUserCart.summary);
  const navigate = useNavigate();
  const { id } = useParams();
  const isSticky = useAppSelector((state) => state.userAuth.isSticky);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Show cart button if there are items in cart
    if (cart?.total_qty > 0) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [cart?.total_qty]);

  if (!isVisible) return null;

  return (
    <div
      className={`${
        isSticky ? "top-20 right-5" : "bottom-5 left-1/2 transform -translate-x-1/2"
      } fixed lg:relative h-[70px] lg:h-full py-2 px-3 lg:bottom-auto lg:left-auto lg:transform-none background-primary rounded-xl shadow-lg z-30 border-2 border-white`}
    >
      <div className="flex items-center min-w-[320px] lg:min-w-[350px] justify-between text-white">
        <div className="flex items-center px-3">
          <div className="relative">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.5 5M7 13l2.5 5m6-5v6a2 2 0 01-2 2H9a2 2 0 01-2-2v-6m8 0V9a2 2 0 00-2-2H9a2 2 0 00-2 2v4.01"
              />
            </svg>
            {cart?.total_qty > 0 && (
              <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-bold">{cart.total_qty}</span>
            )}
          </div>
          <div className="ml-3">
            <div className="text-sm font-medium">{cart?.total_qty} items</div>
            <div className="text-xs opacity-90">{cart?.total_net_weight} gm</div>
          </div>
        </div>

        <div
          className="cursor-pointer py-3 px-4 rounded-lg hover-background-primary transition-all duration-200 font-bold text-sm flex items-center"
          onClick={() => navigate(`/catalogues/${id}/order-cart`)}
        >
          <span>View Cart</span>
          <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default CartButton;
